import React, { Component } from 'react';
import PhotographicLinks from '../components/photographicLinks';
import TradeLinks from '../components/tradeLinks';
import LocalLinks from '../components/localLinks';
import MembersLinks from '../components/membersLinks';

class ClubLinks extends Component {
    render() {
        return (
            <div className="container">
                <h1>Links</h1>
                <MembersLinks />
                <PhotographicLinks />
                <TradeLinks />
                <LocalLinks />
            </div>
        );
    }
}

export default ClubLinks;


// WEBPACK FOOTER //
// ./src/pages/clubLinks.jsx